import { demoFile, component } from 'system/demo';
import { ModDashboardCommentCard } from 'open-modules/zdf/component/moddashboard/moddashboardcommentcard';

const modDashboardDemoData = {
    modulePublic: { moderation: { queue: {}, moderator: {} } },
    modTaskQueues: {
        thread1: {
            c_t1_approved_human: { key: 'task', from: 'a', time: Date.now() },
            c_t1_approved_auto: { key: 'task2', from: 'a', time: Date.now() }
        }
    },
    demoAuthors: {},
    demoModAuthors: {
        c_t1_approved_human: {
            authorName: 'Human',
            authorPhoto: 'https://psi.zdf.de/faces/face1.jpeg',
            authorKey: 'human',
            authorHue: 0,
        },
        c_t1_approved_auto: {
            authorName: 'Auto',
        }
    },
    serverCalls: {}
};

demoFile('open-modules/zdf/component/moddashboard/moddashboardcommentcard');

component('ModDashboardCommentCard', ModDashboardCommentCard, {
    args: {
        modAuthor: modDashboardDemoData.demoModAuthors.c_t1_approved_human,
        modTask: modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_human,
        onPressView: () => {},
        onExpand: () => {},
        onCollapse: () => {},
        highlighted: true,
    },
    state: {
        modulePublic: { moderation: { queue: modDashboardDemoData.modTaskQueues.thread1, moderator: modDashboardDemoData.demoAuthors } },
        serverCall: modDashboardDemoData.serverCalls,
    },
});

